import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/** Legge un motion token del tema attivo (custom property su [data-theme]). Fallback se non trovato. */
export function motionToken(name, fallback) {
  if (typeof window === 'undefined') return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

// Default GSAP allineati ai motion token del tema (vedi theme-[nome].css)
gsap.defaults({
  ease:     motionToken('--ease-default', 'power2.out'),
  duration: parseFloat(motionToken('--duration-base', '0.2ms')) / 1000 || 0.6,
});
ScrollTrigger.defaults({ markers: false });

// Esposizione dev-only (rimossa dal build di produzione via tree-shaking su
// import.meta.env.DEV) — usata da scripts/utils/visual-check.js per uccidere
// i pin prima di uno screenshot full-page (altrimenti gli spacer di pin
// creano vuoti enormi fuori contesto in uno screenshot non interattivo).
if (import.meta.env.DEV) window.__ScrollTrigger = ScrollTrigger;

export { gsap, ScrollTrigger };
